let roomHeightNonResidentialStandard = "2.30";
let roomHeightNonResidentialKomfort = "2.52";

let floorConstructionNonResidentialStandard = "0.00";
let floorConstructionNonResidentialKomfort = "0.10";

let floorConstructionResidentialStandard = "0.21";
let floorConstructionResidentialKomfort = "0.23";

let roomHeightResidentialStandard = "2.52";
let roomHeightResidentialKomfort = "2.62";

let htmlStandard = " m<br><br>STANDARD";
let htmlKomfort = " m<br><br>KOMFORT";

$(function () {
    let toggleSwitch = $('#toggleSwitch');
    toggleSwitch.on('click', toggleSwitchHandler);
    toggleSwitch.removeAttr('checked');
    //toggleSwitchHandler();
});

function toggleSwitchHandler() {
    
    let toggleSwitch = $('#toggleSwitch');
    console.log('toggleSwitchHandler',toggleSwitch.is(":checked"));
    let residential = $('#residential');
    let nonresidential = $('#nonresidential');
    if (toggleSwitch.is(":checked")) {

        $('#roomHeightStandard').attr('value', roomHeightNonResidentialStandard);
        $('label[for="roomHeightStandard"]').html(roomHeightNonResidentialStandard + htmlStandard);

        $('#roomHeightKomfort').attr('value', roomHeightNonResidentialKomfort);
        $('label[for="roomHeightKomfort"]').html(roomHeightNonResidentialKomfort + htmlKomfort);

        $('#floorConstructionStandard').attr('value', floorConstructionNonResidentialStandard);
        $('label[for="floorConstructionStandard"]').html(floorConstructionNonResidentialStandard + htmlStandard);

        $('#floorConstructionKomfort').val(floorConstructionNonResidentialKomfort);
        $('label[for="floorConstructionKomfort"]').html(floorConstructionNonResidentialKomfort + htmlKomfort);
        residential.removeClass('active');
        nonresidential.addClass('active');
    } else {
        $('#roomHeightStandard').attr('value', roomHeightResidentialStandard);
        $('label[for="roomHeightStandard"]').html(roomHeightResidentialStandard + htmlStandard);

        $('#roomHeightKomfort').attr('value', roomHeightResidentialKomfort);
        $('label[for="roomHeightKomfort"]').html(roomHeightResidentialKomfort + htmlKomfort);

        $('#floorConstructionStandard').attr('value', floorConstructionResidentialStandard);
        $('label[for="floorConstructionStandard"]').html(floorConstructionResidentialStandard + htmlStandard);

        $('#floorConstructionKomfort').attr('value', floorConstructionResidentialKomfort);
        $('label[for="floorConstructionKomfort"]').html(floorConstructionResidentialKomfort + htmlKomfort);
        nonresidential.removeClass('active');
        residential.addClass('active');

    }
    //residential.toggleClass('active');
    //nonresidential.toggleClass('active');
}
